import { useMemo } from "react";
import { ArrowLeft } from "lucide-react";
import { QuestionChoices } from "./QuestionChoices";

export const QuestionStep = ({ journey }) => {
  const { currentQuestion: question, selectedPath, visibleQuestions, qIndex, answers,
    prevQuestion, nextQuestion, canAdvance, setAnswer, toggleMulti } = journey;
  const total = visibleQuestions.length;
  const progressStyle = useMemo(() => ({ width: `${((qIndex + 1) / total) * 100}%` }), [qIndex, total]);
  if (!question || !selectedPath) return null;
  return (
    <>
      <button onClick={prevQuestion} data-testid="path-selector-back"
        className="mb-6 inline-flex items-center gap-1.5 text-sm font-medium text-slate-500 transition-colors hover:text-slate-900">
        <ArrowLeft className="h-4 w-4" /> Back
      </button>
      <div className="flex items-center justify-between">
        <p className="overline">{selectedPath.label}</p>
        <span className="text-xs font-medium text-slate-400" data-testid="question-progress">Step {qIndex + 1} of {total}</span>
      </div>
      <div className="mt-3 h-1 w-full overflow-hidden rounded-full bg-slate-100">
        <div className="h-1 rounded-full bg-blue-600 transition-[width] duration-300" style={progressStyle} />
      </div>
      <h2 className="mt-6 font-heading text-2xl font-extrabold tracking-tight text-slate-900 md:text-3xl" data-testid="question-title">
        {question.title}
      </h2>
      {question.help && <p className="mt-2 text-slate-500">{question.help}</p>}
      {(question.type === "single" || question.type === "multi") && (
        <QuestionChoices question={question} answers={answers} setAnswer={setAnswer} toggleMulti={toggleMulti} />
      )}
      {question.type === "text" && (
        <textarea rows={3} className="scc-input mt-6 resize-none" value={answers[question.id] || ""}
          onChange={(event) => setAnswer(question.id, event.target.value)} data-testid="q-text-input" placeholder={question.placeholder} />
      )}
      <div className="mt-8 flex items-center gap-4">
        <button type="button" onClick={nextQuestion} disabled={!canAdvance} data-testid="q-continue"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-primary px-8 py-4 font-medium text-primary-foreground transition-[background-color,transform] duration-300 hover:bg-blue-700 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-50">
          {qIndex < total - 1 ? "Continue" : "Continue to details"}
        </button>
        {question.optional && (
          <button type="button" onClick={nextQuestion} data-testid="q-skip"
            className="text-sm font-medium text-slate-500 transition-colors hover:text-slate-900">Skip</button>
        )}
      </div>
    </>
  );
};